import { jwtDecode } from 'jwt-decode';

// The login/register responses include tokens and integration credentials the
// website never uses. Keep them out of localStorage so an XSS bug can't read them.
const USER_SECRET_KEYS = ['reset_token', 'confirmation_token', 'confirmation_number'];
const BUSINESS_SECRET_KEYS = [
  'api_key',
  'shopify_access_token',
  'shopify_webhook_secret',
  'woo_consumer_key',
  'woo_consumer_secret',
  'woo_webhook_secret',
];

const omit = (object, keys) =>
  Object.fromEntries(Object.entries(object).filter(([key]) => !keys.includes(key)));

export const sanitizeBusiness = (business) =>
  business && typeof business === 'object' ? omit(business, BUSINESS_SECRET_KEYS) : business;

export const sanitizeSession = (session) => {
  if (!session?.user) return session;
  const user = omit(session.user, USER_SECRET_KEYS);
  if (Array.isArray(user.businesses)) {
    user.businesses = user.businesses.map(sanitizeBusiness);
  }
  return { ...session, user };
};

export const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return typeof exp !== 'number' || exp < Date.now() / 1000;
  } catch {
    return true;
  }
};
